import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { DotsVerticalIcon } from '@heroicons/react/outline'

interface MenuItem {
  label: string
  icon: React.ComponentType<{ className?: string }>
  onClick: () => void
}

interface Props {
  items: MenuItem[]
}

export const HeaderMenu = ({ items }: Props) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 mx-1 rounded cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        <DotsVerticalIcon className="h-6 w-6 text-gray-700 dark:text-gray-300" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white dark:bg-gray-700 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-[1100]">
          <div className="px-1 py-1">
            {items.map((item, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    onClick={item.onClick}
                    className={`${
                      active
                        ? 'bg-gray-100 dark:bg-gray-600'
                        : 'text-gray-900 dark:text-gray-100'
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    <item.icon className="mr-2 h-5 w-5" aria-hidden="true" />
                    {item.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
